import { render, staticRenderFns } from "./AssetManagement.vue?vue&type=template&id=3916ef08&scoped=true"
import script from "./AssetManagement.vue?vue&type=script&lang=js"
export * from "./AssetManagement.vue?vue&type=script&lang=js"
import style0 from "./AssetManagement.vue?vue&type=style&index=0&id=3916ef08&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3916ef08",
  null
  
)

export default component.exports